import React from 'react';
import { Layout } from '@fiverr-private/layout_components';
import { ASSETS } from '../../assets';
import { UnusualWayGlow } from '../UnusualWaySection/UnusualWayGlow';
import type { GlowRotation } from './glow.config';
// eslint-disable-next-line no-duplicate-imports
import { GLOW_LEFT_DEFAULT, GLOW_TOP_DEFAULT } from './glow.config';
import { wizardGlow } from './styles.ve.css';

interface WizardGlowProps {
    rotation: GlowRotation;
    /** mobile horizontal offset of the glow centre from 50% (px); desktop left is fixed */
    left?: number;
    /** mobile vertical offset of the glow centre from 50% (px); desktop top is fixed */
    top?: number;
}

export const WizardGlow = ({ rotation, left = GLOW_LEFT_DEFAULT, top = GLOW_TOP_DEFAULT }: WizardGlowProps) => (
    <>
        {/* Desktop (md+): SVG with rotation animation */}
        <Layout
            hidden={{ default: true, md: false }}
            className={wizardGlow}
            position="absolute"
            pointerEvents="none"
            left={{ default: `calc(50% + ${left}px)`, md: 'calc(50% + 26px)' }}
            top={{ default: `calc(50% + ${top}px)`, md: 'calc(50% - 160px)' }}
            width={{ default: '2632.56px', md: '2454px' }}
            height={{ default: '1350.25px', md: '2454px' }}
            style={
                {
                    '--glow-rot': `${rotation.default}deg`,
                    ...(rotation.md !== undefined && { '--glow-rot-md': `${rotation.md}deg` }),
                } as React.CSSProperties
            }
        >
            <UnusualWayGlow />
        </Layout>

        {/* Mobile (< md): single rasterized image for all steps */}
        <Layout
            hidden={{ default: false, md: true }}
            position="absolute"
            pointerEvents="none"
            style={{ inset: 0 }}
            width="100%"
            height="100%"
        >
            <img
                src={ASSETS.unusualWayMobileExtendedBg}
                alt=""
                aria-hidden="true"
                style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover', pointerEvents: 'none' }}
            />
        </Layout>
    </>
);
